import { Box } from '@careguide/theme'
import Link from 'next/link'
import { Container, StyledLink } from './Breadcrumbs.styles'

export type BreadcrumbsProps = {
  breadcrumbs: Array<TODO>
}

const Breadcrumbs = ({ breadcrumbs }: BreadcrumbsProps) => {
  return (
    <Container itemScope={true} itemType={'http://schema.org/'} typeof='BreadcrumbList'>
      {breadcrumbs &&
        breadcrumbs.map((breadcrumb, i) => (
          <Box as='li' key={i} itemScope={true} property='itemListElement' typeof='ListItem'>
            <Link passHref href={breadcrumb.path}>
              <StyledLink property='item' typeof='WebPage'>
                <span property='name'>{breadcrumb.name}</span>
              </StyledLink>
            </Link>
            {i < breadcrumbs.length - 1 && (
              <Box as='span' ml='2' mr='2' aria-hidden>
                &gt;
              </Box>
            )}
            <meta property='position' content={`${i}`} />
          </Box>
        ))}
    </Container>
  )
}

export default Breadcrumbs
